import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useCurrentModal, useModalData } from '../../../components/modals/ModalsContext'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text, { Title } from '../../../packages/kiti/components/presentation/Text'

const ModalHeader = () => {
  const { t } = useTranslation('editGroup')
  const id = useModalData()
  const isEditing = id > 0
  const context = isEditing && 'edit'
  const title = t('title', { context })
  const { label } = useCurrentModal()

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={1}>
          <Title size="h5" bold>
            {label}
          </Title>
        </Col>
      </Grid>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
